<mat-toolbar color="primary">
    <span>Equipe de soin</span>
</mat-toolbar>
<mat-dialog-content>
</mat-dialog-content>